import script from "./TagIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TagIcon.vue?vue&type=script&setup=true&lang=js"

import "./TagIcon.vue?vue&type=style&index=0&id=886a2678&lang=scss"

const __exports__ = script;

export default __exports__